import { Pager } from 'react-bootstrap';

import PaginationFooter from '../../generic/Pagination/PaginationFooter';
import type { Repository } from '../../../types';

type Props = {
  repositories: Repository[];
  page: number;
  pageSize: number;
  totalCount?: number;
  onSetPage: (page: number) => void;
  onSetPageSize: (pageSize: number) => void;
};

/**
 * Pagination for repositories listed for Quick Import. If we have a total count, use our generic pagination component.
 * Otherwise, use the old pagination component. Not all VCS services return a total count.
 */
const RepositoryPagination = ({ repositories, page, pageSize, totalCount, onSetPage, onSetPageSize }: Props) => {
  // If we have a total count, use our generic pagination component.
  if (totalCount !== undefined) {
    return (
      <PaginationFooter
        page={page}
        count={pageSize}
        totalItems={totalCount}
        setPage={onSetPage}
        setCount={onSetPageSize}
        countOptions={[5, 10, 20]}
      />
    );
  }

  // Otherwise, fallback to the old pagination.
  return (
    <div className="text-center">
      <Pager>
        {page > 1 && (
          <Pager.Item previous disabled={page <= 1} onClick={() => onSetPage(page - 1)}>
            &larr; Previous
          </Pager.Item>
        )}
        <Pager.Item disabled>
          <b>Page {page}</b>
        </Pager.Item>
        {repositories.length >= pageSize && (
          <Pager.Item
            next
            disabled={repositories.length < pageSize}
            onClick={() => onSetPage(page + 1)}>
            Next &rarr;
          </Pager.Item>
        )}
      </Pager>
    </div>
  );
};

export default RepositoryPagination;
